import { faExclamation } from '@fortawesome/pro-solid-svg-icons';

/**
 * @deprecated
 * swLoading is an attribute directive, where we provide a **promise** - the one
 * that is necessary to display correctly data inside the element.
 *
 * ## Note!
 * * it's deprecated in favor of {@link coreModule.component:swLoading <sw-loading> component}
 * * it doesn't work well when applied at the same element with other directives, for example:
 * <pre>
 *   <form name="test" sw-loading="value>
 *   </form>
 * </pre>
 *
 * Breaks `<form>` directive
 *
 * ## Usage example
 * <pre>
 *   <div sw-loading="promise">
 *     <content>
 *   </div>
 * </pre>
 */
angular.module('coreModule').directive('swLoading', ($log: ng.ILogService) => ({
  template: require('../../views/sw-loading.html').default,
  restrict: 'A',
  controllerAs: '$ctrl',
  scope: true,

  bindToController: {
    swLoading: '=',
  },

  transclude: true,

  controller: function () {
    const $ctrl = this;

    $ctrl.state = 'pending';

    $ctrl.exclamationIcon = faExclamation;

    $ctrl.$onInit = () => {
      // TODO CORE-663 make swLoading work with rx streams
      if (
        angular.isObject($ctrl.swLoading) &&
        angular.isFunction($ctrl.swLoading.then)
      ) {
        $ctrl.swLoading.then(
          () => {
            $ctrl.state = 'resolved';
          },
          (error: any) => {
            $log.error('error in sw-loading directive', error);

            $ctrl.error = error;
            $ctrl.state = 'rejected';
          },
        );
      }
    };
  },
}));
